import utility from "./utility"

const matchedTicket = {
    ticketImage: null,
    pageCount: null,
    currentPage: 1,

    init: function () {
        matchedTicket.ticketImage = document.getElementById("matched-ticket-image");
        if (!matchedTicket.ticketImage) {
            return;
        }

        [...document.querySelectorAll(".matched-ticket-nav-button")].map(el => {
            el.onclick = () => {
                if (el.dataset.action === "S") {
                    matchedTicket.loadPage(1);
                }
                else if (el.dataset.action === "P") {
                    matchedTicket.loadPage(matchedTicket.currentPage - 1);
                }
                else if (el.dataset.action === "N") {
                    matchedTicket.loadPage(matchedTicket.currentPage + 1);
                }
                else if (el.dataset.action === "E") {
                    matchedTicket.loadPage(matchedTicket.pageCount);
                }
            };
        });

        const printButton = document.getElementById("matched-ticket-print");
        if (printButton) {
            printButton.onclick = () => window.print();
        }

        matchedTicket.pageCount = parseInt(matchedTicket.ticketImage.dataset.pagecount);
        matchedTicket.loadPage(1);
    },

    loadPage: function (page) {
        matchedTicket.setCurrentPage(page);
        matchedTicket.enableNavigationButtons();
        matchedTicket.formatPageNumbers();
        matchedTicket.ticketImage.src = `/api/web/account/get-ticket/?entryId=${matchedTicket.ticketImage.dataset.entry}&page=${matchedTicket.currentPage}&cid=${matchedTicket.ticketImage.dataset.cid}`;
    },

    setCurrentPage: function(page) {
        if (page < 1) {
            page = 1;
        }
        else if (page > matchedTicket.pageCount) {
            page = matchedTicket.pageCount;
        }
        matchedTicket.currentPage = page;
    },

    enableNavigationButtons: function() {
        [...document.querySelectorAll(".matched-ticket-nav-button")].map(el => utility.removeClass(el, "disabled"));
        if (matchedTicket.currentPage === 1) {
            [...document.querySelectorAll(".matched-ticket-nav-button:nth-child(-n+2)")].map(el => utility.addClass(el, "disabled"));
        }
        if (matchedTicket.currentPage === matchedTicket.pageCount) {
            [...document.querySelectorAll(".matched-ticket-nav-button:nth-last-child(-n+2)")].map(el => utility.addClass(el, "disabled"));
        }
    },

    formatPageNumbers: function() {
        let numbers = "";
        let min = 1;
        let max = matchedTicket.pageCount;

        if (matchedTicket.currentPage === min && max > 3) {
            max = 3;
        }
        else if (matchedTicket.currentPage === max && min < matchedTicket.pageCount - 2) {
            min = matchedTicket.pageCount - 2;
        }
        else {
            min = matchedTicket.currentPage > 1 ? matchedTicket.currentPage - 1 : min;
            max = matchedTicket.currentPage < matchedTicket.pageCount ? matchedTicket.currentPage + 1 : max;
        }
        if (min > 1) {
            numbers += "<span>..</span>";
        }
        for (let i = min; i <= max; i++) {
            if (i === matchedTicket.currentPage) {
                numbers += `<span class='selected'>${i}</span>`;
            }
            else {
                numbers += `<span>${i}</span>`;
            }
        }
        if (max < matchedTicket.pageCount) {
            numbers += "<span>..</span>";
        }
        document.getElementById("matched-ticket-nav-numbers").innerHTML = numbers;
    }
};

export default matchedTicket


// WEBPACK FOOTER //
// ./assets/src/js/classes/matchedTicket.js